import { DeviceCode, DeviceCodeStatus, Flow } from '@myrtls/api-interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';
import {
    createFlowAction,
    createFlowFailureAction,
    createFlowSuccessAction,
    deleteDeviceAction,
    deleteDeviceFailureAction,
    deleteDeviceSuccessAction,
    deleteFlowAction,
    deleteFlowFailureAction,
    deleteFlowSuccessAction,
    generateFlowDeviceCodeAction,
    generateFlowDeviceCodeFailureAction,
    generateFlowDeviceCodeSuccessAction,
    getCodeStatusSuccessAction,
    getFlowsAction,
    getFlowsFailureAction,
    getFlowsSuccessAction,
    stopPollingCodeStatusAction,
    updateDeviceNoteAction,
    updateDeviceNoteFailureAction,
    updateDeviceNoteSuccessAction,
    updateFlowAction,
    updateFlowFailureAction,
    updateFlowSuccessAction,
} from './flows.actions';

export interface FlowsState {
    flows: Flow[] | null;
    flowsLoading: boolean;
    flowsError: HttpErrorResponse | null;
    deviceCode: DeviceCode | null;
    deviceCodeLoading: boolean;
    deviceCodeStatus: DeviceCodeStatus | null;
}

const initialState: FlowsState = {
    flows: null,
    flowsLoading: false,
    flowsError: null,
    deviceCode: null,
    deviceCodeLoading: false,
    deviceCodeStatus: null,
};

const reducer = createReducer(
    initialState,
    on(getFlowsAction, state => ({
        ...state,
        flowsLoading: true,
    })),
    on(getFlowsSuccessAction, (state, { flows }) => ({
        ...state,
        flowsLoading: false,
        flows,
    })),
    on(getFlowsFailureAction, (state, { error }) => ({
        ...state,
        flowsLoading: false,
        flowsError: error,
    })),
    on(createFlowAction, state => ({
        ...state,
        flowsLoading: true,
    })),
    on(createFlowSuccessAction, state => ({
        ...state,
        flowsLoading: false,
    })),
    on(createFlowFailureAction, (state, { error }) => ({
        ...state,
        flowsLoading: false,
        flowsError: error,
    })),
    on(updateFlowAction, state => ({
        ...state,
        flowsLoading: true,
    })),
    on(updateFlowSuccessAction, state => ({
        ...state,
        flowsLoading: false,
    })),
    on(updateFlowFailureAction, (state, { error }) => ({
        ...state,
        flowsLoading: false,
        flowsError: error,
    })),
    on(deleteFlowAction, state => ({
        ...state,
        flowsLoading: true,
    })),
    on(deleteFlowSuccessAction, state => ({
        ...state,
        flowsLoading: false,
    })),
    on(deleteFlowFailureAction, (state, { error }) => ({
        ...state,
        flowsLoading: false,
        flowsError: error,
    })),
    on(updateDeviceNoteAction, state => ({
        ...state,
        flowsLoading: true,
    })),
    on(updateDeviceNoteSuccessAction, state => ({
        ...state,
        flowsLoading: false,
    })),
    on(updateDeviceNoteFailureAction, (state, { error }) => ({
        ...state,
        flowsLoading: false,
        flowsError: error,
    })),
    on(deleteDeviceAction, state => ({
        ...state,
        flowsLoading: true,
    })),
    on(deleteDeviceSuccessAction, state => ({
        ...state,
        flowsLoading: false,
    })),
    on(deleteDeviceFailureAction, (state, { error }) => ({
        ...state,
        flowsLoading: false,
        flowsError: error,
    })),
    on(getCodeStatusSuccessAction, (state, deviceCodeStatus) => ({
        ...state,
        deviceCodeStatus,
    })),
    on(generateFlowDeviceCodeAction, state => ({
        ...state,
        deviceCode: null,
        deviceCodeStatus: null,
        deviceCodeLoading: true,
    })),
    on(generateFlowDeviceCodeSuccessAction, (state, deviceCode) => ({
        ...state,
        deviceCodeLoading: false,
        deviceCode,
    })),
    on(generateFlowDeviceCodeFailureAction, state => ({
        ...state,
        deviceCodeLoading: false,
    })),
    on(stopPollingCodeStatusAction, state => ({
        ...state,
    })),
);

export function flowsReducer(
    state: FlowsState | undefined,
    action: Action,
): FlowsState {
    return reducer(state, action);
}
